var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "secondarybackground",
      staticStyle: { "overflow-y": "auto" },
      attrs: { height: "200" }
    },
    [
      _c("v-card-text", { staticClass: "caption" }, [
        _c(
          "div",
          { staticClass: "font-weight-bold subtitle-2 ml-5 font-italic" },
          [_vm._v("\n      " + _vm._s(_vm.item.equipment_type) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v("Matériel :")
          ]),
          _vm._v("\n      " + _vm._s(_vm.item.equipment) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "font-weight-bold" }, [_vm._v("Marque :")]),
          _vm._v("\n      " + _vm._s(_vm.item.brand_name) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v("Référence :")
          ]),
          _vm._v("\n      " + _vm._s(_vm.item.model) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "font-weight-bold" }, [_vm._v("Nombre :")]),
          _vm._v("\n      " + _vm._s(_vm.item.number_of_equipment) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v("Dimension :")
          ]),
          _vm._v(
            "\n\n      " +
              _vm._s(
                _vm.item.sizing_value &&
                  _vm.item.sizing_unit &&
                  `${_vm.item.sizing_value} ${_vm.item.sizing_unit}`
              ) +
              "\n    "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }